import { useMemo } from "react";
import { CustomProvider } from "rsuite";
import { rSuiteTranslationsForLocale } from "./Utils/rSuiteLocaleUtils";

const RSuiteProvider = ({ locale, children }) => {
  const translations = useMemo(() => rSuiteTranslationsForLocale(locale), [locale]);

  return <CustomProvider locale={translations}>{children}</CustomProvider>;
};

export default RSuiteProvider;
